import Logo from "public/images/k-logo.svg";
import { Image } from "components/image";

export const HEADER = {
  logo: {
    href: "/",
    title: <Logo />,
    alt: "Karan Desai Logo",
  },
  nav: [
    {
      href: "/",
      title: "Home",
      alt: "Home",
      desktop: false,
    },
    {
      href: "/#about",
      title: "About",
      alt: "More about me",
      desktop: true,
    },
    // {
    //   href: "/#portfolio",
    //   title: "Projects",
    //   alt: "Work I've done.",
    //   desktop: true,
    // },
    {
      href: "/resume",
      title: "Resume",
      alt: "My professional resume",
      desktop: true,
    },
  ],
  profileNav: [],
};
